/** MongoDB ObjectId: 24 hex chars (12 bytes). */
export function isLikelyMongoObjectId(value) {
  return typeof value === "string" && /^[a-fA-F0-9]{24}$/.test(value);
}

/**
 * Values like "www.example.com" resolve as relative paths in <a href>.
 * Returns a safe absolute href for http(s) navigation.
 */
export function absoluteHttpHref(url) {
  if (url == null || typeof url !== "string") return "";
  const trimmed = url.trim();
  if (!trimmed) return "";
  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(trimmed)) return trimmed;
  if (trimmed.startsWith("//")) return trimmed;
  return `https://${trimmed}`;
}
